import React, { useState, useEffect } from 'react';
import { Row, Col,Result, Input, Button} from 'antd';
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom";
import useWindowDimensions from '../../hooks/windowDimensionsHook'
import backgroundImg from '../../imagens/backgroundverde.jpg';
import logoevConnect from '../../imagens/evconnect.png';
import { Content } from 'antd/lib/layout/layout';
import { connect } from 'react-redux'
import AsyncStorage from '@react-native-async-storage/async-storage';


const { TextArea } = Input;

function Termos ({ usuario, definirUsuario }) {
    const location = useLocation();
    let history = useHistory();
    const { height, width } = useWindowDimensions();

    useEffect(async () => {
        var aceito = await AsyncStorage.getItem('termos')
        if(aceito){
            history.push({
                pathname: usuario.perfil == 'Admin' ? '/dashboard' : '/nfs',
                state: { detail: usuario }
            });
        }
        console.log(location.pathname); 
        console.log(location.state.detail); 
    }, [location]);


    async function Aceitar()
    {
        await AsyncStorage.setItem('termos', true);
         history.push({
            pathname: usuario.perfil == 'Admin' ? '/dashboard' : '/nfs',
            state: { detail: usuario }
          });
    }

    function Sair() {
      definirUsuario(undefined)
      history.push({
           pathname: '/',
      });
    }
    return (
        <Content>
            <Row style={{ height: height }}>
                {
                    width > 600 ? (
                        <Col style={{ height: height, backgroundImage: 'url(' + backgroundImg + ')', backgroundSize: "cover", }} xs={24} sm={24} md={16} lg={16} xl={16}>
                            <Row style={{ padding: 20, marginTop: height / 2 - 200 }}>
                                <Col span={4}></Col>
                                <Col span={16}>
                                    <Row>
                                    <Result style={{color:'#fff'}}
                                            status="success"
                                    />
                                    </Row>
                                    <Row>
                                        <h1 style={{color:'#fff'}}>LGPD: Lei Geral de Proteção de Dados</h1>
                                        <p style={{color:'#fff'}}>A Lei Geral de Proteção de Dados é a lei nº 13.709, aprovada em agosto de 2018. Ela cria normas para a coleta e tratamento de dados pelas empresas.</p>
                                    </Row>
                                </Col>
                                <Col span={4}></Col>
                            </Row>
                        </Col>

                    ) : null
                }
                <Col style={{ height: height }} xs={24} sm={24} md={8} lg={8} xl={8} style={{
                    backgroundColor: '#eee',
                }}>
                    <Row style={{ padding: 20 }}>
                        <Col span={4}></Col>
                        <Col span={16}><img width={240} src={logoevConnect} /> </Col>
                        <Col span={4}></Col>
                    </Row>
                    <Row style={{ padding: 20 }}>
                        <h2>Ola, {usuario.nome}  - {usuario.baseOperacional}</h2>
                        <h3>Aceitar os termos de uso do software</h3>
                    </Row >
                    <Row style={{ padding: 20 }}>
                        <TextArea rows={10} style={{ width: '100%' }} >
                       </TextArea>
                    </Row>
                    <Row style={{ padding: 20 }}>
                        <Button shape="round" onClick={() => Aceitar()} style={{ width: 200, marginRight: 10, backgroundColor: '#168e6d', borderColor: '#168e6d' }} type="primary" >
                            Concordo que li e aceito
                    </Button>
                    <Button onClick={Sair} shape="round" style={{ width: 100, backgroundColor: 'red', borderColor: 'red' }} type="primary">
                            Sair
                    </Button>
                    </Row>
                </Col>
            </Row>
        </Content>


    );
}

const mapState = (state) => ({
    usuario: state.usuario.usuario,
})
const mapDispatch = (dispatch) => ({
  definirUsuario: dispatch.usuario.definirUsuario,
})

export default connect(mapState, mapDispatch)(Termos)